import React, { createContext, useContext, useState } from "react"

interface salesReturnCrudContextType<T> {
  openSalesReturnDialog: boolean
  setOpenSalesReturnDialog: (value: boolean) => void
  selectedsalesReturnRow: T | null
  setSelectedSalesReturnRow: (value: T | null) => void
}

const salesReturnCrudContext = createContext<salesReturnCrudContextType<any>>({
  openSalesReturnDialog: false,
  setOpenSalesReturnDialog: () => {},
  selectedsalesReturnRow: null,
  setSelectedSalesReturnRow: () => {},
})

export const SalesReturnCrudProvider = <T,>({
  children,
}: {
  children: React.ReactNode
}) => {
  const [openSalesReturnDialog, setOpenSalesReturnDialog] = useState(false)
  const [selectedsalesReturnRow, setSelectedSalesReturnRow] =
    useState<T | null>(null)

  return (
    <salesReturnCrudContext.Provider
      value={{
        openSalesReturnDialog,
        setOpenSalesReturnDialog,
        selectedsalesReturnRow,
        setSelectedSalesReturnRow,
      }}
    >
      {children}
    </salesReturnCrudContext.Provider>
  )
}

export function useSalesReturnCrudContext<T>() {
  return useContext(salesReturnCrudContext) as salesReturnCrudContextType<T>
}
